<template>
  <v-app>
    <v-app-bar
      app
      color="deep-purple"
      dark
      max-height="64px"
      dense
      style="overflow: auto"
    >
    
      <div class="d-flex align-center">
        <v-btn
          to="/"
          target="_self"
          class="mr-2 ml-n4"
          text
        > 
          <v-icon dark>
            mdi-home
          </v-icon>
        </v-btn>
        <v-btn
          to="/assessment"
          target="_self"
          class="mr-1"
          text
        >
          <span>採点</span>
        </v-btn>
        <v-btn
          to="/record"
          target="_self"
          class="mr-1"
          text
        >
          <span>記録</span>
        </v-btn>
        <v-btn
          to="/ranking"
          target="_self"
          class="mr-1"
          text
        >
          <span>ランキング</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        to="/Login"
        target="_self"
        text
      >
        <span v-if="!$store.state.user">Login</span>
        <span v-if="$store.state.user">Logout</span>
      </v-btn>
    </v-app-bar>

    <v-main class="mb-10">
      <router-view/>
    </v-main>

    <template>
      <v-footer
        color="#B39DDB"
        padless
      >
        <v-row
          justify="center"
          no-gutters
        >
          <v-btn
            v-for="link in links"
            :key="link.title"
            :to="link.url"
            color="white"
            text
            rounded
            class="my-2"
          >
            {{ link.title }}
          </v-btn>
        </v-row>
      </v-footer>
    </template>


  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
      links: [
        { 'title' : 'お問合せ/ご意見', 'url' : '/contact' },
        { 'title' : 'About Us', 'url' : '' },
      ],
  }),
};
</script>
